import { UserSubscriptionType } from '../../services';

export enum MembershipType {
  Owner = 'Owner',
  Guest = 'Guest',
  Shared = 'Shared',
}

export type RoomOwner = {
  id: string;
  title?: string | null;
  firstName: string;
  lastName: string;
  displayName?: string | null;
};

export type RoomAdmin = {
  id: string;
  title?: string | null;
  firstName: string;
  lastName: string;
  displayName?: string | null;
  userProfilePictureUrl?: string | null;
  subscriptionType: UserSubscriptionType;
  authId?: string | null;
};

export type RoomV2 = {
  id: string;
  membershipType: MembershipType;
  slug: string;
  passcode?: string | null;
  isPasscodeEnabled: boolean;
  cameraOff: boolean;
  owner?: RoomOwner | null;
  sharedRoomDisplayName?: string | null;
};

export type NodeRoomV2 = {
  node: RoomV2;
};

export type RoomForPatient = {
  id: string;
  legacyId?: number | null;
  slug: string;
  name: string;
  passcode?: string | null;
  usePasscode?: boolean | null;
  displayName?: string | null;
  isPersonal: boolean;
  usePasscodeStoredValue?: boolean | null;
  redirectUrl?: string | null;
  shouldRedirect?: boolean | null;
  checkInPhotoCapture?: boolean | null;
  roomAdmin: RoomAdmin;
};
